import { useCallback, useEffect } from 'react';
import { IUsePoliticalAdsLoggerProps, PoliticalAdsTask } from '../types';

// Export as a standalone function to reuse easily in other components
export const logPoliticalAdsFlowClickedContinue = (logTrace: (message: string) => void, task: PoliticalAdsTask, value: boolean) => {
  if (typeof logTrace === 'function') {
    logTrace(`[political-ads] clicked continue with isChecked: ${value}, task: ${task}`);
  }
};

export const usePoliticalAdsDeclarationLogger = ({
  task,
  logger,
}: IUsePoliticalAdsLoggerProps) => {
  /**
   * Logs a trace message on hook call if the logger is provided and has a trace method.
   */
  const logTrace = useCallback((message: string) => {
    if (logger && logger.trace && typeof logger.trace === 'function') {
      logger.trace(message);
    }
  }, [logger]);

  /**
   * Logs once on component mount
   */
  useEffect(() => {
    logTrace(`[political-ads] rendered political ads declaration, task: ${task}`);
  }, [task, logTrace]);


  /**
   * Logs when the user toggles a selection
   * @param value The selected value
   */
  const logToggledSelection = useCallback((value: boolean) => {
    logTrace(`[political-ads] toggled selection to isChecked: ${value}, task: ${task}`);
  }, [task, logTrace]);

  return {
    logToggledSelection,
  };
};
